import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

// Props:
//   features: [{ id, code, label, sub_features: [{ id, code, label, assigned, default_enabled, plan_gated }] }]
//   selectedIds: Set<number>
//   onToggle: (subFeatureId, nextChecked) => void
//   onToggleAll: (feature, nextChecked) => void
const PlanFeatureChecklist = ({ features, selectedIds, onToggle, onToggleAll }) => {
  const [expanded, setExpanded] = useState({});

  const toggle = (id) => setExpanded((e) => ({ ...e, [id]: !e[id] }));

  const counts = (feature) => {
    const total = feature.sub_features.length;
    const enabled = feature.sub_features.filter((sf) => selectedIds.has(sf.id)).length;
    return { enabled, total };
  };

  return (
    <div className="bg-card rounded-lg border border-border divide-y divide-gray-100">
      {features.map((feature) => {
        const { enabled, total } = counts(feature);
        const allOn = enabled === total;
        const isOpen = expanded[feature.id];

        return (
          <div key={feature.id}>
            <div className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-muted/50"
                 onClick={() => toggle(feature.id)}>
              <div className="flex items-center gap-2">
                {isOpen ? <ChevronDown className="h-4 w-4 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
                <span className="text-sm font-medium text-foreground">{feature.label}</span>
                {!isOpen && (
                  <span className="text-xs text-muted-foreground ml-2">({enabled} / {total})</span>
                )}
              </div>
              <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                <button
                  type="button"
                  onClick={() => onToggleAll(feature, true)}
                  className={`text-xs px-2 py-1 rounded border ${allOn ? 'bg-black text-white border-black' : 'bg-card text-foreground border-input hover:bg-muted/50'}`}
                >
                  ✓ All
                </button>
                <button
                  type="button"
                  onClick={() => onToggleAll(feature, false)}
                  className={`text-xs px-2 py-1 rounded border ${enabled === 0 ? 'bg-black text-white border-black' : 'bg-card text-foreground border-input hover:bg-muted/50'}`}
                >
                  — None
                </button>
              </div>
            </div>

            {isOpen && (
              <div className="px-10 pb-3">
                {feature.sub_features.map((sf) => {
                  const checked = selectedIds.has(sf.id);
                  return (
                    <label key={sf.id} className="flex items-center gap-3 py-1.5 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => onToggle(sf.id, e.target.checked)}
                        className="h-4 w-4 rounded border-input"
                      />
                      <span className="text-sm text-foreground">{sf.label}</span>
                      {sf.plan_gated && <span className="text-xs text-amber-600">plan-gated</span>}
                    </label>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PlanFeatureChecklist;
